import { render, staticRenderFns } from "./choose-notice.vue?vue&type=template&id=011997e4&"
import script from "./choose-notice.vue?vue&type=script&lang=js&"
export * from "./choose-notice.vue?vue&type=script&lang=js&"
import style0 from "./choose-notice.vue?vue&type=style&index=0&id=011997e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports